import { mountApp, setupSentry } from "@/main.js";
import store from '@/pages/habitat/store.js';
import router from '@/pages/habitat/router.js';
import Index from '@/pages/habitat/Index.vue';
import 'vite/modulepreload-polyfill';

const app = mountApp(Index, {store: store, router: router});
const sentry = setupSentry(app);
app.config.globalProperties.$sentry = sentry;
app.mount('#habitat');
